<div class="portlet light">
  <div  *ngIf="this.isShipping else noShipping">
    <storever-header-page [icon]="'fal fa-shipping-fast'"
                          [title]="(shipping$|async)?.displayName ? (shipping$|async)?.displayName : title"
                          [isEdit]="isEdit">

    </storever-header-page>
    <div class="portlet-body">
      <storever-shipping-add
        [isLoading]="isLoading"
        [form]="form"
        [shippingForm]="shippingForm"
        [isEdit]="isEdit"
        [isAdd]="isAdd"
        [siteSummaries]="siteSummaries$ | async"
        [addressSummaries]="addressSummaries$ | async"
        [dataContext]="dataContext"
      ></storever-shipping-add>
    </div>
    <storever-footer-form
      [disabledSaveBtn]="dhlValidation"
      [extraInfo]="dhlResult"
      [simpleFooter]="true"
      [form]="form"
      [isEdit]="isEdit"
      [isSiteShippingEdit]="isSiteShippingEdit"
      (saveOutput)="save($event, form)"
      (resetOutput)="resetForm(form)"
      (cancelOutput)="cancel()"
    ></storever-footer-form>
  </div>

  <ng-template #noShipping>
    <div class="is-shipping"> {{ 'ORDERS_DETAILS_SHIPPING_ATTACHED_MESSAGE' | translate:locale.language}}  </div>
  </ng-template>
</div>
